// extracted by mini-css-extract-plugin
module.exports = {"clause":"Clause_clause__EcgPQ","title":"Clause_title__4DPdA","one":"Clause_one__3rsqt","msg":"Clause_msg__6QKe8","two":"Clause_two__UQwNF","a":"Clause_a__3sW9G"};